// extracted by mini-css-extract-plugin
export default {"badgeHeight":"_1u6y5rp","badgeBorder":"_1ric1x6"};